export enum SubscriptionManagementCancelOption {
  AtEnd = 'AtEnd',
  // Now = 'Now',  //Will be added in the future
  NowAndDeleteData = 'NowAndDeleteData',
}
